<template>
  <div class="table-actions">
    <div class="table-actions_right">
      <slot name="action-buttons"></slot>

      <div v-on-click-away="hideSettingsDropdownDropdown" class="table-settings_wrapper table-icon_wrapper">
        <div
          v-tooltip.left="$tr('common.table.settings')"
          class="table-settings table-icon"
          @click="isSettingsDropdownVisible = !isSettingsDropdownVisible"
        >
          <i class="icon icon-gear"></i>
        </div>

        <transition name="fade">
          <div v-if="isSettingsDropdownVisible" class="table-settings_dropdown">
            <div class="table-settings_title">{{ $tr('common.table.columns') }}</div>

            <div v-for="header in headers" :key="header.id" class="table-settings_item">
              <vchecklabel v-model="header.is_visible" :label="header.name" @input="$emit('changeVisible')" />
            </div>
          </div>
        </transition>
      </div>

      <div
        v-on-click-away="hideSaveDropdownDropdown"
        class="table-icon_wrapper"
        :class="{ active: currentTableSetting !== null }"
      >
        <div
          v-tooltip.left="$tr('common.table.saveSettings')"
          class="table-save table-icon"
          @click="isSaveDropdownVisible = !isSaveDropdownVisible"
        >
          <i class="icon icon-save"></i>
        </div>

        <div v-if="isSaveDropdownVisible" class="table-settings_dropdown">
          <div class="table-settings_title">{{ $tr('common.table.list') }}</div>

          <div v-for="item in settings" :key="item.name" class="table-settings_item">
            <vcirclelabel v-model="item.is_active" :label="item.name" @input="setTableSettings(item.name)" />

            <div v-if="!item.is_base" class="row-icon" @click="deleteTableSettings(item.name)">
              <i class="icon icon-recycle_bin"></i>
            </div>
          </div>

          <div class="table-settings_footer">
            <div class="table-settings_save" @click="toggleSavingModalVisible(true)">
              <i class="icon icon-save cv-row-icon"></i>
              <span>{{ $tr('common.table.saveSettings') }}</span>
            </div>
          </div>
        </div>

        <div v-if="currentTableSetting !== null" class="table-settings__current">
          <span>{{ currentTableSetting.name }}</span>

          <div class="table-settings__current-close" @click="setDefaultTablePreset">&times;</div>
        </div>

        <modal v-if="isSavingModalVisible" class="saving-modal" redesign @close="toggleSavingModalVisible(false)">
          <div slot="header">
            <h3 class="header-title">{{ $tr('common.table.saveTitle') }}</h3>
          </div>

          <div slot="body">
            <p>{{ $tr('common.table.saveDescription') }}</p>

            <div class="saving-block">
              <label for="">{{ $tr('common.table.name') }}</label>

              <input v-model="tableName" type="text" :placeholder="$tr('common.table.namePlaceholder')" />

              <vchecklabel v-model="saveFilters" :label="$tr('common.table.saveFilters')" />
            </div>
          </div>

          <div slot="footer">
            <div class="buttons-wrapper">
              <vbutton
                color="grey"
                text_color="grey-dark"
                :text="$tr('common.cancel')"
                @click="toggleSavingModalVisible(false)"
              />

              <vbutton :disabled="tableNameEmpty" :text="$tr('common.save')" @click="saveTableSettings" />
            </div>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as VueClickAway } from 'vue-clickaway';
import Modal from '@/components/Modal.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'TableActions',

  components: {
    Modal
  },

  directives: {
    onClickAway: VueClickAway
  },

  props: ['headers', 'settingsList', 'isSavingModalVisible'],

  data() {
    return {
      isSettingsDropdownVisible: false,
      isSaveDropdownVisible: false,
      saveFilters: false,
      tableName: ''
    };
  },

  computed: {
    settings() {
      return [
        {
          id: 'default',
          name: this.$tr('common.table.default'),
          is_active: this.settingsList.find(item => item.is_active) ? false : true,
          is_base: true
        },
        ...this.settingsList
      ];
    },

    currentTableSetting() {
      return this.settingsList.filter(x => x.is_active)[0] || null;
    },

    tableNameEmpty() {
      return !this.tableName.trim();
    }
  },

  methods: {
    ...mapMutations('responses', { clearAllFilters: 'clear' }),

    ...mapActions('responses', { fetchResponses: 'fetch' }),

    saveTableSettings() {
      this.$emit('saveTableSettings', { name: this.tableName, saveFilters: this.saveFilters });
      this.toggleSavingModalVisible(false);
    },

    deleteTableSettings(name) {
      this.$emit('deleteTableSettings', name);
    },

    hideSettingsDropdownDropdown() {
      this.isSettingsDropdownVisible = false;
    },

    hideSaveDropdownDropdown() {
      this.isSaveDropdownVisible = false;
    },

    toggleSavingModalVisible(val) {
      this.$emit('changeModalVisible', val);

      if (!val) {
        this.saveFilters = false;
        this.tableName = '';
      }
    },

    setTableSettings(name) {
      this.$emit('setTableSettings', name);
    },

    async setDefaultTablePreset() {
      const defaultPreset = this.settings.filter(x => x.is_base && x.id === 'default')[0];
      this.$emit('setTableSettings', defaultPreset.name);
      this.$emit('cancel_filter');

      this.clearAllFilters(); // clear all filters in responses
      await this.fetchResponses(); // fetch responses
    }
  }
};
</script>
